
import { CODE_FORM, LOAI_CHUC_NANG, MATERIALS_GROUP, TYPE_WH, WAREHOUSE_ID } from "../utils/Constant";
import PhieuInXuatKho from "./PhieuInXuatKho";
import PhieuInNhapKho from "./PhieuInNhapKho";

export const danhSachTabPhieuIn = (typeKho?: any, listCodeCN?: any) => [

    {
        eventKey: "1",
        title: "Nhập kho",
        component: <PhieuInNhapKho
            warehouseId={typeKho?.id}
            className="h-bang-ds-phieu-bao-hiem"
        />,
    },
 {
        eventKey: "2",
        title: "Xuất kho",
        component: <PhieuInXuatKho
            warehouseId={typeKho?.id}
            className="h-bang-ds-phieu-bao-hiem"
        />,
    },
];


export { };